import {match} from 'ts-pattern';

import {FinancingCompositionScene} from '@dms/api/shared';

import {compositionEditorLimits} from '../constants/compositionEditorLimits';
import {LayerBox} from '../types/CompositionEditorAction';

const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(Math.round(value), min), max);

/**
 * Applies one typed inspector value to a layer box. A position keeps the size and stops at the
 * canvas edge; a size keeps the position and shrinks to the space left before the canvas edge, so
 * typing a too-large width or height never moves the layer.
 */
export const applyLayerBoxInput = (
  box: LayerBox,
  field: keyof LayerBox,
  value: number,
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>
): LayerBox =>
  match(field)
    .with('x', () => ({...box, x: clamp(value, 0, canvas.width - box.width)}))
    .with('y', () => ({...box, y: clamp(value, 0, canvas.height - box.height)}))
    .with('width', () => ({
      ...box,
      width: clamp(value, compositionEditorLimits.minLayerSize, canvas.width - box.x),
    }))
    .with('height', () => ({
      ...box,
      height: clamp(value, compositionEditorLimits.minLayerSize, canvas.height - box.y),
    }))
    .exhaustive();
